import React from "react";
import { t } from "i18next";
import { Input } from "antd";
import { getMany, updateOrderById, softDeleteById } from "services/payroll_item";
import { Util } from "common/util";
import withDataTable from "../withDataTable";
import FormInsertOrUpdate from "./FormInsertOrUpdate";
import Enum from "common/enums";

const util = new Util();
const pathName = "/setting/payroll-item";
const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 10;

if (current) {
  defaultCurrent = current;
}

if (size) {
  defaultPageSize = size;
}
const columns = [
  {
    title: t("text_no"),
    dataIndex: "id",
    key: "id",
    width: 70,
    render: (id, record, index) => {
      const size = new URLSearchParams(document.location.search).get("size");
      const current = new URLSearchParams(document.location.search).get(
        "current"
      );
      let defaultCurrent = 1;
      let defaultPageSize = 10;

      if (current) {
        defaultCurrent = current;
      }

      if (size) {
        defaultPageSize = size;
      }
      return (defaultCurrent - 1) * defaultPageSize + (index + 1);
    },
  },
  {
    title: t("text_name"),
    dataIndex: "title",
    key: "title",
  },
  {
    title: t("text_name_Kh"),
    dataIndex: "titleKH",
    key: "titleKH",
  },
  {
    title: t("text_type"),
    dataIndex: "type",
    key: "type",
    render: (type) => {
      if (type === Enum.PAYROLL_ITEM_TYPE.TAXABLEEARNING)  return t("text_taxable_earning")  
      if (type === Enum.PAYROLL_ITEM_TYPE.NONTAXABLEEARNING) return t("text_non_taxable_earning");
      if (type === Enum.PAYROLL_ITEM_TYPE.TAXABLE_DEDUCTION) return t("text_taxable_deduction");
      if (type === Enum.PAYROLL_ITEM_TYPE.DEDUCTION) return t("text_non_taxable_defuction");
      if (type === Enum.PAYROLL_ITEM_TYPE.EXCLUDE) return t("text_exclude_item");
      if (type === Enum.PAYROLL_ITEM_TYPE.PENSION_FUND) return t("text_pension_fund");
      if (type === Enum.PAYROLL_ITEM_TYPE.ALLOWANCE) return t("text_allowance");
    },
  },
  {
    title: t("text_order"),
    dataIndex: "order",
    key: "order",
    width: 100,
    render: (order, record) => {
      return <Input defaultValue={order} onFocus={e => e.target.select()} style={{textAlign: "center"}} onChange={(e) => updateOrderById(record.id, e.target.value)} />
    }
  },
];

const getData = () => {
  let limit = defaultPageSize;
  let current = defaultCurrent;
  let option = {};
  const params = new URLSearchParams(document.location.search);
  const searchStr = params.get("search");

  if (params.get("size")) {
    limit = params.get("size");
  }

  if (params.get("current")) {
    current = params.get("current");
  }

  option["limit"] = limit;
  option["offset"] = (current - 1) * limit;

  if (searchStr) {
    option["search"] = searchStr;
  }

  return getMany(option);
};

const handleSearch = (e) => {
  const queryParams = new URLSearchParams(document.location.search);
  const value = e.target.value;
  if (value) {
    queryParams.set("search", value);
  } else {
    queryParams.delete("search");
  }
  util.pushParamsToURL(pathName, queryParams.toString());
};

export default withDataTable({
  title: t("text_payroll_item"),
  showPagination: true,
  columns,
  defaultCurrent,
  defaultPageSize,
  getData,
  handleSearch,
  pathName,
  FormInsertOrUpdate,
  handleAddNew: (modalRef) => modalRef.showModal(),
  handleShowUpdate: (id, modalRef) => modalRef.showModal(id),
  confirmSoftDelete: (id) => softDeleteById(id),
});
